import { useMemo } from "react";
import { useRouter } from "next/router";
import query from "@insightfulscience/smart-react/url/query";
import useGlobalContex from "../global-context/hook";

function useQueryString() {
	const context = useGlobalContex();
	const router = useRouter();

	const { asPath } = router || context;

	return useMemo(
		() => query(asPath), // factory
		[asPath],
	);
}

export default useQueryString;
